import axios from "axios";
import { GetUserMetadataRequest, GetUserMetadataResponse } from "redmond";
import { config } from "../../config";
import { userMetadataPath } from "../paths";

export const fetchUserMetadata = (
  body: GetUserMetadataRequest
): Promise<GetUserMetadataResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(userMetadataPath, body, {
        baseURL: config.baseURL,
      });

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });

export default fetchUserMetadata;
